// @flow
import { useContext } from 'react';

import i18n from 'shared/language/init';
import { UserContext } from 'shared/userContext/UserContext';

export function useCopy(namespace?: string, scope?: string) {
  const resourceNamespace = namespace || useContext(UserContext).type; // TODO turn this into a pure function by getting rid of the useContext here (rely on passed type)

  const getCopy = (path: string, attributes: Object = {}) => {
    if (scope) {
      path = `${scope}.${path}`;
    }

    return i18n.t(path, { ns: resourceNamespace, ...attributes });
  };

  const getCopyJSX = (path: string, attributes: Object = {}): any => {
    if (scope) {
      path = `${scope}.${path}`;
    }

    const copy = i18n.t(path, { ns: resourceNamespace, returnObjects: true });

    return typeof copy === 'function' ? copy(attributes) : copy;
  };

  return {
    getCopy,
    getCopyJSX
  };
}
